
export type MessagingDeleteMessage200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
